module.exports = __webpack_public_path__ + "static/media/inspector-icon-active.70666cfa.svg";